import * as React from 'react'
import styles from './RiotChat.module.less'

export interface RiotChatProps {
    roomUrl: string
}

export class RiotChat extends React.Component<RiotChatProps> {
    render() {
        return (
            <div>
                <iframe
                    className={styles.riotChatContainer}
                    src={this.props.roomUrl}
                />
            </div>
        )
    }
}
